import { render } from "./BlocoNoticias.vue?vue&type=template&id=5604b405&scoped=true"
import script from "./BlocoNoticias.vue?vue&type=script&lang=js"
export * from "./BlocoNoticias.vue?vue&type=script&lang=js"

import "./BlocoNoticias.vue?vue&type=style&index=0&id=5604b405&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5604b405"]])

export default __exports__